import { Link } from "react-router-dom"
import { formatCurrency } from "../services/helpers";

export function CustomerTile({customer}){
	return <div className="info-tile">
		{/* <div className="image-section">
			<img src="https://avatar.iran.liara.run/public/43" alt="" />
		</div> */}
		<div className="primary-info-section">
			<b>
				{`${customer.first_name} ${customer.other_names} ${customer.last_name}`}
				{ customer.member_id && <span className={`member-label ${customer.is_membership_active ? "active" : ""}`}>{customer.member_id}</span>}
			</b>
			{customer.total_spend && <span>Total Spend GHS {formatCurrency(customer.total_spend)}</span>}

		</div>
		{
			!customer.license_plate ?
		<div className="secondary-info-section">
			<p><small>No Vehicle</small></p>

		</div>
			:
		<div className="secondary-info-section">
			<b><Link className="blue-text" to={`/dashboard/vehicles/${customer.license_plate}/services`}>{customer.license_plate} </Link></b>
			<p>{customer.vehicle_name} ({customer.vehicle_year})</p>
		</div>
		}
		<div className="action-section col">
			<Link className="red-text" to={`/dashboard/members/u/${customer.uuid}/vehicles`}>Details </Link>
			<Link className="blue-text" to={`/dashboard/services/add_ticket`} state={{"customer_id": customer.uuid}}> Create Order Ticket </Link>
			{/* <Link className="blue-text" to={`/dashboard/members/u/${customer.uuid}/add_order`}> Create Order Ticket </Link> */}
			{/* <Link className="blue-text" to="/dashboard/members/u/4">Message </Link> */}
		</div>
	</div>
}